<script setup lang="ts">
import MAlert from '~/components/molecules/Alert.vue'
import { useAuth } from '~/store/auth'

const isShowingPopup = ref(false)

onMounted(() => {
  if (import.meta.server) {
    return
  }

  const userStore = useAuth()
  const cookieAgreement = useCookie('session_alert_showed', {
    path: '/',
    expires: new Date(Date.now() + 10 * 365 * 24 * 3600 * 1000),
  })
  if (userStore.user === null && !cookieAgreement.value) {
    showPopup()
    cookieAgreement.value = 'true'
  }
})

const showPopup = () => {
  isShowingPopup.value = true
}

const closePopup = () => {
  isShowingPopup.value = false
}

</script>

<template>
  <MAlert
    :style="isShowingPopup ? {} : { display: 'none !important' }"
    class="cookie-popup"
    position="start"
    @close="closePopup"
  >
    <template #text>
      <span class="cookie-popup__text d-inline">
        Пользуясь нашим сайтом, вы&nbsp;соглашаетесь с&nbsp;тем, что&nbsp;
        <a
          href="/legal/privacy-policy.pdf"
          target="_blank"
          class="alert-link"
        >мы&nbsp;используем cookies</a>&nbsp;🍪
      </span>
    </template>
  </MAlert>
</template>

<style lang="scss" scoped>
.cookie-popup {
  position: fixed;
  bottom: rem(8px);
  right: rem(8px);
  z-index: 999;
  margin: 0;
  max-width: rem(400px);

  @include media-breakpoint-down(sm) {
    left: rem(12px);
    right: rem(12px);
    max-width: 100%;
  }

  &__text {
    font-size: rem(14px);
    color: $blue-700;
    margin-right: rem(8px);
  }

  .alert-link {
    font-weight: 400;
    color: inherit;
    text-decoration: underline;

    @media (any-hover: hover) {
      &:hover {
        color: $indigo-500;
      }
    }
  }
}
</style>
